import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// ---- Styles (order matters) ----
import './styles/tokens.css';
import './styles/global.css';
import './styles/tiles.css';
import './styles/table.css';
import './styles/responsive.css';

import App from './App';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
